import { Badge } from "@mantine/core";
import { IpawsChannel } from "src/gql/graphql";
import { match } from "ts-pattern";

export const IpawsChannelBadge = (props: { type: IpawsChannel }) =>
    match(props.type)
        .with(IpawsChannel.Eas, () => <Badge color="blue">EAS</Badge>)
        .with(IpawsChannel.Cmas, () => <Badge color="red">WEA</Badge>)
        .with(IpawsChannel.Nwem, () => <Badge color="violet">NWEM</Badge>)
        .with(IpawsChannel.Capexch, () => <Badge color="orange">CAPEXCH</Badge>)
        .with(IpawsChannel.Public, () => <Badge color="green">PUBLIC</Badge>)
        .exhaustive();
